import Vue from 'vue';
import Router from 'vue-router';

import Information from '@/views/Information.vue';
import Discography from '@/views/Discography.vue';
import Biography from '@/views/Biography.vue';
import Album from '@/views/Album.vue';
import Demo from '@/views/Demo.vue';

import DistributionAlbum from '@/views/DistributionAlbum.vue';
import Distribution from '@/views/Distribution.vue';

import AboutSite from '@/views/AboutSite.vue';
import NotFound from '@/views/404.vue';

import Constants from '@/constants';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: `${process.env.BASE_URL}/`,
  routes: [
    {
      path: '/',
      name: Constants.ROUTER.INDEX,
      component: Information,
    },
    {
      path: '/biography',
      name: Constants.ROUTER.BIOGRAPHY,
      component: Biography,
    },
    {
      path: '/discography',
      name: Constants.ROUTER.DISCOGRAPHY,
      component: Discography,
    },
    {
      path: '/album10',
      name: Constants.ROUTER.ALBUM10,
      component: Album,
    },
    {
      path: '/album11',
      name: Constants.ROUTER.ALBUM11,
      component: Album,
    },
    {
      path: '/album12',
      name: Constants.ROUTER.ALBUM12,
      component: Album,
    },
    {
      path: '/album13',
      name: Constants.ROUTER.ALBUM13,
      component: Album,
    },
    {
      path: '/album14',
      name: Constants.ROUTER.ALBUM14,
      component: Album,
    },
    {
      path: '/album15',
      name: Constants.ROUTER.ALBUM15,
      component: Album,
    },
    {
      path: '/demo',
      name: Constants.ROUTER.DEMO,
      component: Demo,
    },
    {
      path: '/distribution',
      name: Constants.ROUTER.DISTRIBUTION,
      component: Distribution,
    },
    {
      path: '/distribution10',
      name: Constants.ROUTER.DISTRIBUTION10,
      component: DistributionAlbum,
    },
    {
      path: '/distribution11',
      name: Constants.ROUTER.DISTRIBUTION11,
      component: DistributionAlbum,
    },
    {
      path: '/distribution12',
      name: Constants.ROUTER.DISTRIBUTION12,
      component: DistributionAlbum,
    },
    {
      path: '/distribution13',
      name: Constants.ROUTER.DISTRIBUTION13,
      component: DistributionAlbum,
    },
    {
      path: '/distribution14',
      name: Constants.ROUTER.DISTRIBUTION14,
      component: DistributionAlbum,
    },
    {
      path: '/distribution15',
      name: Constants.ROUTER.DISTRIBUTION15,
      component: DistributionAlbum,
    },
    {
      path: '/aboutsite',
      name: Constants.ROUTER.ABOUTSITE,
      component: AboutSite,
    },
    { // 404
      path: '*',
      name: Constants.ROUTER.NOTFOUND,
      component: NotFound,
    },
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
